import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import { branding } from "./resources"

if (!branding.staticLanguage) {
    i18n.use(LanguageDetector)
}

i18n.use(Backend)
    .use(initReactI18next)
    .init({
        debug: false,
        ...(branding.staticLanguage && { lng: branding.language }), // No automatic language detection if staticLanguage is true. --- That is set in the resources file.
        fallbackLng: 'en', // This should never change as it is the last resort if no other language is found.
    });
export default i18n;